"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorToolController = void 0;
var TopologicalEditorToolController = /** @class */ (function () {
    function TopologicalEditorToolController(topologicalEditorController) {
        this.topologicalEditorController = topologicalEditorController;
    }
    return TopologicalEditorToolController;
}());
exports.TopologicalEditorToolController = TopologicalEditorToolController;
//# sourceMappingURL=topological.editor.tool.abstract.ctrl.js.map